import { put, take, fork, call } from 'redux-saga/effects'
import { cardDuplicateService } from 'src/api/card'
import { CARD_CLONE } from 'src/reducers/card/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

function* cardCloneFlow(payload) {
  try {
    const { cardId, courseId, callback } = payload

    const response = yield call(cardDuplicateService, cardId, courseId)

    yield put(operationSuccess())
    callback(response.data)
  } catch (error) {
    yield put(operationFail(error))
  }
}

export default function* cardCloneWatcher() {
  while (true) {
    const action = yield take(CARD_CLONE)
    const { payload } = action
    yield fork(generalSaga, cardCloneFlow, payload)
  }
}
